function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "#FF4E00",
  rx: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 11.575v6.85c0 .076.014.15.042.22.03.07.071.134.125.188.053.054.117.096.187.125.07.028.145.043.221.042h6.85c.076 0 .15-.014.22-.042.07-.03.135-.071.188-.125.054-.053.096-.117.125-.187.028-.07.043-.145.042-.221v-6.85c0-.076-.014-.15-.042-.22-.03-.07-.071-.135-.125-.188-.053-.054-.117-.096-.187-.125-.07-.028-.145-.043-.221-.042h-6.85c-.076 0-.15.014-.22.042-.07.03-.135.071-.188.125-.054.053-.096.117-.125.187-.028.07-.043.145-.042.221zm-2 0c0-.338.066-.673.195-.986.129-.313.318-.597.558-.836.239-.24.523-.43.836-.558.313-.13.648-.196.986-.195h6.85c.338 0 .674.065.986.195.313.129.597.318.836.558.24.239.43.523.558.836.13.313.196.648.195.986v6.85c0 .338-.066.674-.195.986-.129.313-.319.597-.558.836-.239.24-.523.43-.836.558-.313.13-.648.196-.986.195h-6.85c-.338 0-.673-.066-.986-.195-.313-.129-.597-.319-.836-.558-.24-.239-.43-.523-.558-.836-.13-.313-.196-.648-.195-.986v-6.85z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.571 17.857c.076-.001.149-.032.202-.086.054-.055.084-.128.084-.204v-.935c-.004-.094-.04-.184-.1-.256l-1.324-1.456c-.062-.069-.145-.065-.201-.01l-1.803 1.804-.47-.469c-.013-.014-.029-.025-.046-.032-.018-.008-.037-.012-.056-.012-.02 0-.038.004-.055.012-.018.007-.034.018-.047.032L12.34 17.66c-.105.105-.066.197.095.197h5.136z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.286 14.429c.631 0 1.143-.512 1.143-1.143s-.512-1.143-1.143-1.143-1.143.512-1.143 1.143.512 1.143 1.143 1.143z"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  width: 38,
  height: 38,
  x: -4,
  y: -4,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

var SvgPic = function SvgPic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pic.ff5b725d.svg";
export { ForwardRef as ReactComponent };